/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import { WithPreview } from "@quintype/components";
import "array-flat-polyfill";
import get from "lodash/get";
import { array, func, object, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setStoryHeader } from "../helper/actions";
import BlankStory from "../story-templates/blank";
import LiveBlog from "../story-templates/liveBlog";
import PhotoStory from "../story-templates/photo";
import VideoStory from "../story-templates/Video";
import { googleTagEvents } from "../utils/utils";

import "./story.m.css";

export function StoryPageBase({ story, relatedStories }) {
  let summaryText;
  let startingCard = 0;
  const summaryMeta = get(story, ["metadata", "summary"], "");

  if (summaryMeta) {
    summaryText = `<p>${summaryMeta}</p>`;
  } else {
    const firstCard = get(story, ["cards", "0", "story-elements"]);
    const summaryElement = firstCard.filter((item) => item.subtype === "summary");
    summaryText = get(summaryElement, ["0", "text"], "");
    startingCard = summaryText.length && 1;
  }

  const imageElements = story.cards
    .map((card) => card["story-elements"].filter((item) => item && item.type === "image"))
    .flat();

  switch (story["story-template"]) {
    case "live-blog":
      return (
        <div styleName="story-page-wrapper">
          <LiveBlog story={story} imageElements={imageElements} />
        </div>
      );
    case "video":
      return (
        <div styleName="story-page-wrapper">
          <VideoStory story={story} relatedStories={relatedStories} summary={summaryText} />
        </div>
      );
    case "photo":
      return (
        <div styleName="story-page-wrapper">
          <PhotoStory
            story={story}
            relatedStories={relatedStories}
            summary={summaryText}
            imageElements={imageElements}
          />
        </div>
      );
    case "gallery":
      return (
        <div styleName="story-page-wrapper">
          <PhotoStory
            story={story}
            relatedStories={relatedStories}
            summary={summaryText}
            imageElements={imageElements}
          />
        </div>
      );
    default:
      return (
        <div styleName="story-page-wrapper">
          <BlankStory
            story={story}
            relatedStories={relatedStories}
            summary={summaryText}
            imageElements={imageElements}
            startingCard={startingCard}
          />
        </div>
      );
  }
}

StoryPageBase.propTypes = {
  story: object,
  relatedStories: array,
};

const StoryPageView = (props) => {
  useEffect(() => {
    const headerElement = global.document.getElementById("top-ad");
    if (headerElement) {
      headerElement.style.cssText = "min-height: 0";
    }
  }, []);

  props.data.story["story-template"] === "video" &&
    props.setStoryHeader({
      headline: props.data.story.headline,
      section: props.data.story.sections[0]["display-name"],
      slug: props.data.story.slug,
      sectionUrl: props.data.story.sections[0]["section-url"],
      url: props.data.story.url,
      story: props.data.story,
    });

  const sectionId = get(props, ["data", "story", "sections", "0", "id"]);
  // NTG
  const [scroll, setScroll] = useState(0);
  const scrollEventTrigger = (value, pageTitle) => {
    googleTagEvents("article-milestone", pageTitle, value);
  };
  useEffect(() => {
    const scrollCalculate = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded >= 25 && scrollPercentRounded < 50) {
        if (scroll < 25) {
          setScroll(25);
          scrollEventTrigger(25, `${props.data.story.headline}`);
        }
      } else if (scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        if (scroll < 50) {
          setScroll(50);
          scrollEventTrigger(50, `${props.data.story.headline}`);
        }
      } else if (scrollPercentRounded >= 75 && scrollPercentRounded < 90) {
        if (scroll < 75) {
          setScroll(75);
          scrollEventTrigger(75, `${props.data.story.headline}`);
        }
      } else if (scrollPercentRounded >= 90) {
        if (scroll < 90) {
          setScroll(90);
          scrollEventTrigger(100, `${props.data.story.headline}`);
        }
      }
    };
    if (window) {
      window.addEventListener("scroll", scrollCalculate);
      return () => {
        window.removeEventListener("scroll", scrollCalculate);
      };
    }
  }, [scroll]);

  return <StoryPageBase story={props.data.story} relatedStories={props.data.relatedStories} />;
};

StoryPageView.propTypes = {
  data: object,
  setStoryHeader: func,
  publisherAttributes: object,
  domainSlug: string,
  config: object,
};

const mapDispatchToProps = (dispatch) => ({
  setStoryHeader: (storyHeaderObj) => dispatch(setStoryHeader(storyHeaderObj)),
});

export const StoryPagePreview = WithPreview(StoryPageView, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story),
  })
);

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "domainSlug"], ""),
  config: get(state, ["qt", "config"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export const StoryPage = connect(mapStateToProps, mapDispatchToProps)(StoryPageView);
